"use strict";

var LoggerInstance = require("js-logger").get("SearchApi");

var AbstractApi = require("./AbstractApi");

var SearchApi = class extends AbstractApi {
	recordClicked(data) {
		return this.post({
			url: "/api/searchterms/resultsclicked",
			data
		});
	}
};

module.exports = new SearchApi();
